import styled, { css } from 'styled-components';
import { styles } from '../../consts';

const buttonWrapperMinHeight = 3;

const { fontMBank } = styles;

export const LoaderWrapper = styled.div<{
  height: number | undefined;
}>`
  ${props =>
    props.height &&
    css`
      height: ${props.height}px;
    `};

  @media (min-width: 768px) {
    margin-top: 0.875rem;
  }
`;

export const CenterText = styled.div`
  padding: 0.2rem 0;
  text-align: center;
  font-family: ${fontMBank};
`;
export const ButtonWrapper = styled.div<{
  isRecoveryEnabled: boolean | undefined;
  isTokenizationEnabled: boolean | undefined;
}>`
  position: relative;
  min-height: ${buttonWrapperMinHeight}rem;

  @media (min-width: 768px) {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  ${props =>
    props.isRecoveryEnabled &&
    !props.isTokenizationEnabled &&
    css`
      .statusbar__pending_recovery_button {
        margin: 0.6875rem 0 1.6875rem;
      }

      .payment-button-loader {
        @media (min-width: 768px) {
          margin: 0.4375rem 0 0.625rem;
        }
      }

      .payment-button__container {
        margin: 0.4rem 0 0.4rem;
      }
    `}

  ${props =>
    props.isTokenizationEnabled &&
    css`
      .payment-button__container {
        margin: 0.625rem 0 0.625rem;
      }

      .payment-button-loader {
        @media (min-width: 768px) {
          margin: 0.625rem 0 0.625rem;
        }
      }
    `}
`;

export const InnerButtonWrapper = styled.div`
  transition: height 400ms ease-in-out;
`;

export const PaymentCardWrapper = styled.div`
  @media (max-width: 767px) {
    padding-top: 0.5rem;
  }
`;

export const CheckboxWrapper = styled.div`
  padding-bottom: 0.5rem;
`;
